import { useBranding } from '@/lib/branding/BrandingProvider';
import { GuideSection } from '@/components/guides/GuideSection';
import { GuideCallout } from '@/components/guides/GuideCallout';

const CHECKLIST = [
  'A laptop running macOS 13+ or Windows 10+.',
  'A working microphone (built-in is fine; a USB headset is better).',
  'A stable internet connection — ideally wired or strong Wi-Fi.',
  'The onboarding email from your recruiter with the company code and license key.',
  '15 minutes before your first interview to install and test the app.',
];

export function BeforeYouStartSection() {
  const brand = useBranding();
  return (
    <GuideSection
      id="before-you-start"
      eyebrow="Before you start"
      title={`Meet ${brand.productName}`}
      description="Your interview intelligence buddy. Here's what it does and what you'll need to run it."
    >
      <div className="space-y-3 text-sm text-muted-foreground">
        <p>
          <strong className="text-white">{brand.productName}</strong> runs quietly on your laptop
          during an interview. It listens to the conversation, understands what the interviewer is
          asking, and surfaces real-time hints, structure, and reminders to help you answer better.
          No one else on the call sees it — it's your private coaching pane.
        </p>
        <p>
          You keep full control. The app only speaks when you look at it; it never interrupts the
          interview or makes noise.
        </p>
      </div>

      <div className="glass-card p-5">
        <h3 className="mb-3 font-display text-base font-semibold text-white">Make sure you have</h3>
        <ul className="space-y-2 text-sm text-muted-foreground">
          {CHECKLIST.map((item) => (
            <li key={item} className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-neurax-electric" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <GuideCallout variant="tip" title="Why install it early">
        <p>
          Installing and testing the app <strong>the day before</strong> your interview lets you
          catch mic or permission issues when it doesn't matter. Don't save the setup for five
          minutes before a live interview.
        </p>
      </GuideCallout>
    </GuideSection>
  );
}
